import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import { UNIFIED_FEED_DOMAIN_SERVICE } from 'constants/index';
import makeRequest from 'utils/makeRequest';
import Cookie from 'utils/cookies';
import LoaderSpinner from 'components_v2/common/LoaderSpinner/LoaderSpinner';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import s from './LocationGuesserGame.scss';
import LocationGuesserPlayer from './LocationGuesserPlayer';
import GameOverlay from '../GameOverlay/GameOverlay';
import {
  loadSyncUp,
  loadLocationGuesserStateFetch,
  loadLocationGuesserStateSave,
} from '../../../redux';
import CongratulationsNew from '../CongratulationsNew/CongratulationsNew';
// import GameCardListing from '../GameCardListing/GameCardListing';
// import PracticeCard from '../PracticeCard/PracticeCard';
import LoaderSplash from '../LoaderSplash/LoaderSplash';
import { fireGa4, fireGa4andGrx } from '../../../layouts/utils';
import Map from '../Map/Map';
import MoreOnGames from '../MoreOnGames/MoreOnGames';

const LocationGuesserGame = props => {
  const {
    puzzleAPI,
    apiConfigData,
    isMobile,
    userData,
    todaysGame,
    stateData,
    buttonClicked,
    handleGameCallback,
    gameSolutionData,
    viewSolution,
    showCongratulationsData,
  } = props;

  const [showOverlay, setShowOverlay] = useState(false);
  const [popUpType, setPopUpType] = useState('');
  const [showLoader, setLoader] = useState(false);
  const [resultData, setResultData] = useState(undefined);
  const [showCongrate, setCongrate] = useState(
    showCongratulationsData || false,
  );
  const [puzzle, setPuzzle] = useState([]);
  const [hasSynced, setHasSynced] = useState(false);
  const [hideResultMap, setHideResultMap] = useState(false);
  const [mapData, setMapData] = useState({
    guesses: [],
  });
  const [mapDataResultView, setMapDataResultView] = useState({
    guesses: [],
    solution: [],
    isResultView: false,
  });
  const [hasGameAlreadyBeenPlayed, setHasGameAlreadyBeenPlayed] = useState(
    false,
  );
  const [isLoading, setIsLoading] = useState(false);
  const [failedAPI, setFailedAPI] = useState('');

  const gameType = 'location-guesser';
  const gameId = puzzleAPI && puzzleAPI.gameId ? puzzleAPI.gameId : '';
  const jsonUrl = puzzleAPI && puzzleAPI.url ? puzzleAPI.url : '';
  let grxId = Cookie.get('_grx');
  let ssoId = Cookie.get('ssoid');
  grxId = grxId || '';
  ssoId = ssoId || '';

  let playAgainCheckTemp = false;
  if (typeof localStorage !== 'undefined') {
    let toigames = localStorage.getItem('toigames');
    toigames = toigames ? JSON.parse(toigames) : {};
    playAgainCheckTemp =
      toigames.playagainlg && toigames.playagainlg.includes(gameId);
  }

  const commonTranslations = _get(
    props,
    'gamesconfigData.translations.commonTranslations',
    {},
  );
  const gameSpecificTranslations = _get(
    props,
    'gamesconfigData.translations.gameSpecificTranslations.locationGuesser',
    {},
  );

  const [playAgainCheck, setPlayAgainCheck] = useState(playAgainCheckTemp);
  const userDataRef = useRef(userData);

  const showLoaderCL = () => {
    setIsLoading(true);
  };

  const clearLocalStorage = key => {
    try {
      if (typeof localStorage !== 'undefined') {
        localStorage.removeItem(key);
      }
    } catch (error) {
      console.error('Error parsing JSON from localStorage>>', error);
    }
  };

  const clearPlayAgain = () => {
    if (typeof localStorage !== 'undefined') {
      let toigames = localStorage.getItem('toigames');
      toigames = toigames ? JSON.parse(toigames) : {};
      let playagainArray =
        toigames.playagainlg && toigames.playagainlg.split(',');
      if (playagainArray && playagainArray.includes(gameId)) {
        playagainArray = playagainArray.filter(id => id !== gameId);
        toigames.playagainlg = playagainArray.join(',');
        localStorage.setItem('toigames', JSON.stringify(toigames));
      }
    }
  };

  const fireGaGameScreen = (gaLabelText, score = '', gaType) => {
    const gaData = {
      event: 'user_shown_games',
      type: gaType || 'gameplay_screen',
      label: gaLabelText,
      page_template: 'gameplay',
      section: 'games',
      subsection: 'location_guesser',
      browsing_platform: isMobile ? 'mweb' : 'web',
      game_id: gameId,
      level: 'N/A',
      game_of_the_day: window.location.href.toLowerCase().includes('/today'),
      login_status: !!ssoId,
      user_grx_id: grxId,
    };
    if (ssoId) {
      gaData.sso_id = ssoId;
    }
    if (score) {
      gaData.score = score;
    }
    analyticsWrapper('ga4', gaData);
    analyticsWrapper('grx', 'track', 'user_shown_games', gaData);
  };

  const overlayCall = popuptype => {
    setShowOverlay(true);
    setPopUpType(popuptype);
  };

  const showGameAlreadyPlayedPopup = overlayType => {
    setHasGameAlreadyBeenPlayed(true);
    overlayCall(overlayType);
  };

  const gameStateFetchCall = puzzleData => {
    if (userData?.isLoggedIn && todaysGame && !playAgainCheck) {
      const params = { gameId, gameType, grxId, ssoId };
      props.loadLocationGuesserStateFetch(params);
      return;
    }

    // Fallback to localStorage
    const savedState = localStorage.getItem(`tillocationguesser:${gameId}`);
    if (savedState && buttonClicked !== 'startOver') {
      const localState = JSON.parse(savedState);
      setMapData({
        guesses: localState?.guesses,
      });
      //--- Max Attempts maxGuessExhausted
      if (
        localState &&
        localState.guesses &&
        Array.isArray(localState.guesses) &&
        localState.guesses.length > 0 &&
        localState.guesses[localState.guesses.length - 1] &&
        localState.guesses[localState.guesses.length - 1].pointsEarned &&
        localState.guesses[localState.guesses.length - 1].pointsEarned === 1000
      ) {
        showGameAlreadyPlayedPopup('perfectPointsGuessed');
      } else if (
        localState &&
        localState.guesses &&
        Array.isArray(localState.guesses) &&
        puzzleData &&
        puzzleData.maxAttempts &&
        localState.guesses.length >= puzzleData.maxAttempts
      ) {
        showGameAlreadyPlayedPopup('maxGuessExhausted');
      }
    }
  };

  const getGameJsonCall = () => {
    const url = `${jsonUrl}`;
    makeRequest
      .get(url, {}, 'skipfeedengine')
      .then(data => {
        const puzzleData = data?.data?.config;
        setPuzzle(puzzleData);
        gameStateFetchCall(puzzleData);
        setLoader(false);
      })
      .catch(err => {
        console.log(err);
        setFailedAPI('puzzle_api');
        overlayCall('errorPopUp');
        setLoader(false);
      });
    return false;
  };

  const getStatusCall = () => {
    getGameJsonCall();
    if (buttonClicked !== 'viewResult') {
      showLoaderCL();
    } else {
      setCongrate(true);
      setLoader(true);
    }
    const url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/toi-games/revamp/status/game?pc=toi&pfm=web&gameId=${gameId}&gameType=location_guesser`;
    const requestParams = {
      params: {},
      headers: {
        grxId,
        ssoId,
      },
    };
    makeRequest
      .get(url, requestParams, 'skipfeedengine')
      .then(data => {
        if (
          data &&
          data.data &&
          data.data.hasPlayed &&
          data.data.items &&
          Array.isArray(data.data.items) &&
          !playAgainCheck
        ) {
          const gameCongratulationsData = data.data.items.filter(
            item => item.tn === 'gameCongratulationsData',
          )[0];
          if (
            gameCongratulationsData &&
            gameCongratulationsData.gameCongratulationsData
          ) {
            // gameCongratulationsData.gameCongratulationsData.greetTitle = `FINAL Final score ${
            //   gameCongratulationsData?.gameCongratulationsData
            //     ?.locationsGuessedData?.bestGuessPoints
            // } / 1000`;
            // gameCongratulationsData.gameCongratulationsData.maxAttempts =
            //   puzzle?.maxAttempts;
            const loggedInResult = !!(grxId && ssoId);
            setResultData({
              ...gameCongratulationsData.gameCongratulationsData,
              loggedInResult,
            });
            const tempGameScore =
              gameCongratulationsData?.gameCongratulationsData
                ?.achievementCards &&
              Array.isArray(
                gameCongratulationsData?.gameCongratulationsData
                  ?.achievementCards,
              ) &&
              gameCongratulationsData?.gameCongratulationsData
                ?.gameCongratulationsData?.achievementCards?.length !== 0
                ? gameCongratulationsData?.gameCongratulationsData?.achievementCards[0]?.primaryText.replace(
                    ' Points',
                    '',
                  )
                : 'N/A';
            fireGaGameScreen('view_results', tempGameScore, 'results_score');
            if (window && window.lwPlayer && window.lwPlayer.lg) {
              window.lwPlayer.lg.destroy();
            }
            // if (
            //   gameCongratulationsData?.gameCongratulationsData
            //     ?.locationsGuessedData?.guessedItems
            // ) {
            //   const dataResultGuess =
            //     gameCongratulationsData.gameCongratulationsData
            //       .locationsGuessedData.guessedItems;
            //   setMapDataResultView({
            //     guesses: dataResultGuess,
            //     isResultView: true,
            //   });
            // }
          }
          setLoader(false);
          setCongrate(true);
          clearLocalStorage(`tillg:${gameId}`);
        } else {
          if (playAgainCheckTemp) {
            clearPlayAgain(gameId);
          }
          //getGameJsonCall();
          setCongrate(false);
          setLoader(false);
          fireGaGameScreen(
            buttonClicked === 'resumeButton' ? 'resume_game' : 'start_game',
          );
        }
        return false;
      })
      .catch(err => {
        console.log(err);
        setFailedAPI('status_api');
        overlayCall('errorPopUp');
        setLoader(false);
        fireGaGameScreen('start_game');
      });
    return false;
  };

  const howtoPlaycheck = popuptype => {
    setShowOverlay(true);
    setPopUpType(popuptype);
    if (window?.lwPlayer?.lg) {
      window.lwPlayer.lg.pause();
    }
  };

  useEffect(() => {
    getStatusCall();
  }, []);

  // Handle solution data when viewSolution is true
  useEffect(
    () => {
      if (viewSolution && gameSolutionData && puzzle) {
        const solutionStateData = gameSolutionData?.stateLocationGuesser;
        const solutionGuesses = solutionStateData?.guessedItems;

        if (solutionGuesses && Array.isArray(solutionGuesses)) {
          setCongrate(true);
          setLoader(false);
          setIsLoading(false);

          // Set up the result view with solution data
          setMapDataResultView({
            guesses: solutionGuesses,
            isResultView: true,
          });

          // Create result data using the solution data structure
          const resultDataFromSolution = {
            greetTitle: `Final score ${solutionStateData?.bestGuessPoints ||
              0} / 1000`,
            maxAttempts: puzzle?.maxAttempts,
            locationsGuessedData: {
              locationName: solutionStateData?.locationName || puzzle?.location,
              bestGuessDistance: solutionStateData?.bestGuessDistance,
              bestGuessPoints: solutionStateData?.bestGuessPoints,
              guessedItems: solutionGuesses,
            },
          };

          setResultData(resultDataFromSolution);
        } else {
          console.log(
            'SolutionGuesses is not available or not an array:',
            solutionGuesses,
          );
        }
      }
    },
    [viewSolution, gameSolutionData, puzzle],
  );

  const gameOverlayCallback = () => {
    setShowOverlay(false);
  };

  const handleMap = () => {
    setShowOverlay(true);
    setPopUpType('lgMap');
    if (window?.lwPlayer?.lg) {
      window.lwPlayer.lg.pause();
    }
  };

  const gameStateSaveCall = data => {
    try {
      // If logged in, save to server
      if (userData?.isLoggedIn && todaysGame && !playAgainCheck) {
        const params = {
          gameId,
          gameType,
          grxId,
          ssoId,
          guesses: [...data.guesses],
        };
        props.loadLocationGuesserStateSave(params);
      }
    } catch (e) {
      console.error('Error saving game state:', e);
    }
  };

  const gamePointsCalculationCall = (latitude, longitude) => {
    const url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/utility/location/guesser/score`;
    const postData = {
      orgLatitude: puzzle.latitude,
      orgLongitude: puzzle.longitude,
      guessedLatitude: latitude,
      guessedLongitude: longitude,
    };

    setLoader(true);
    makeRequest
      .post(url, postData, {})
      .then(data => {
        if (data && data.data) {
          const dataToSet = {
            guessLatitude: latitude,
            guessLongitude: longitude,
            distanceFromLocationInKms: data.data.distanceInKms,
            pointsEarned: data.data.pointsEarned,
          };
          setMapData(prevMapData => {
            const updatedMapData = {
              ...prevMapData,
              guesses: [...prevMapData.guesses, dataToSet],
            };
            localStorage.setItem(
              `tillocationguesser:${gameId}`,
              JSON.stringify(updatedMapData),
            );
            gameStateSaveCall(updatedMapData);

            return updatedMapData;
          });
        }
        setLoader(false);
      })
      .catch(err => {
        console.error(err);
        setFailedAPI('score_api');
        overlayCall('errorPopUp');
        setLoader(false);
      });
    return false;
  };

  const gameSyncCall = () => {
    let user = {};
    if (userDataRef && userDataRef.current && userDataRef.current.isLoggedIn) {
      user = userDataRef.current;
    }
    const params = {
      userName:
        user && typeof user.getFirstName === 'function'
          ? user?.getFirstName()
          : 'N/A',
      userImage:
        user && typeof user.getIcon === 'function' ? user?.getIcon() : '',
      grxId,
      ssoId,
    };
    props.loadSyncUp(params);
  };

  const getHighestPoints = array => {
    if (!array || array.length === 0) {
      return null;
    }

    let maxPoints = -Infinity;
    let selectedItem = null;

    array.forEach(item => {
      if (item.pointsEarned >= maxPoints) {
        maxPoints = item.pointsEarned;
        selectedItem = item;
      }
    });

    return selectedItem;
  };

  const gameSubmitCall = guesses => {
    setLoader(true);
    if (!guesses || guesses.length === 0) {
      setFailedAPI('submit_api_zero_guesses');
      overlayCall('errorPopUp');
      return null;
    }
    const url = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/toi-games/revamp/submit/game?pc=toi&pfm=web&fv=1250&gameId=${gameId}&gameType=location_guesser`;
    let user = {};
    if (userDataRef && userDataRef.current && userDataRef.current.isLoggedIn) {
      user = userDataRef.current;
    }
    const bestGuess = getHighestPoints(guesses);
    const postData = {
      locationsGuessedData: {
        locationName: puzzle?.location,
        bestGuessDistance: bestGuess?.distanceFromLocationInKms,
        bestGuessPoints: bestGuess?.pointsEarned,
        guessedItems: guesses,
      },
      userName:
        user && typeof user.getFirstName === 'function'
          ? user?.getFirstName()
          : 'N/A',
      userImage:
        user && typeof user.getIcon === 'function' ? user?.getIcon() : '',
    };
    makeRequest
      .post(url, postData, { headers: { grxId, ssoId } })
      .then(data => {
        if (data && data.data && Array.isArray(data.data.items)) {
          setPlayAgainCheck(false);
          const gameCongratulationsData = data.data.items.filter(
            item => item.tn === 'gameCongratulationsData',
          )[0];
          if (
            gameCongratulationsData &&
            gameCongratulationsData.gameCongratulationsData
          ) {
            // gameCongratulationsData.gameCongratulationsData.greetTitle = `Final score ${
            //   gameCongratulationsData?.gameCongratulationsData
            //     ?.locationsGuessedData?.bestGuessPoints
            // } / 1000`;
            // gameCongratulationsData.gameCongratulationsData.maxAttempts =
            //   puzzle?.maxAttempts;
            const loggedInResult = !!(grxId && ssoId);
            setResultData({
              ...gameCongratulationsData.gameCongratulationsData,
              loggedInResult,
            });
            const tempGameScore =
              gameCongratulationsData?.gameCongratulationsData
                ?.achievementCards &&
              Array.isArray(
                gameCongratulationsData?.gameCongratulationsData
                  ?.achievementCards,
              ) &&
              gameCongratulationsData?.gameCongratulationsData
                ?.gameCongratulationsData?.achievementCards?.length !== 0
                ? gameCongratulationsData?.gameCongratulationsData?.achievementCards[0]?.primaryText.replace(
                    ' Points',
                    '',
                  )
                : 'N/A';
            fireGaGameScreen('submit_game', tempGameScore, 'results_score');
            if (window && window.lwPlayer && window.lwPlayer.lg) {
              window.lwPlayer.lg.destroy();
            }
            // if (
            //   gameCongratulationsData?.gameCongratulationsData
            //     ?.locationsGuessedData?.guessedItems
            // ) {
            //   const dataResultGuess =
            //     gameCongratulationsData.gameCongratulationsData
            //       .locationsGuessedData.guessedItems;
            //   setMapDataResultView({
            //     guesses: dataResultGuess,
            //     isResultView: true,
            //   });
            // }
            window.scrollTo({
              top: 0,
              behavior: 'smooth', // Adds a smooth scrolling effect
            });
          }
          setCongrate(true);
          setLoader(false);
        }
        setShowOverlay(false);
        setLoader(false);
        clearLocalStorage(`tillocationguesser:${gameId}`);
        return false;
      })
      .catch(err => {
        console.error(err);
        setFailedAPI('submit_api');
        overlayCall('errorPopUp');
        setLoader(false);
      });
    return false;
  };

  const submitGuessCallback = (latitude, longitude) => {
    gamePointsCalculationCall(latitude, longitude);
  };

  const gameSubmitCallback = guesses => {
    gameSubmitCall(guesses);
  };

  useEffect(
    () => {
      if (typeof props.loadSyncUp === 'function') {
        userDataRef.current = userData;
        if (userData && userData.isLoggedIn && !hasSynced) {
          gameSyncCall();
          setHasSynced(true);
        }
      }
    },
    [userData, hasSynced],
  );

  useEffect(
    () => {
      if (
        stateData &&
        stateData.stateLocationGuesser &&
        stateData.stateLocationGuesser.guesses &&
        buttonClicked !== 'startOver'
      ) {
        setMapData(stateData.stateLocationGuesser);
        localStorage.setItem(
          `tillocationguesser:${gameId}`,
          JSON.stringify(stateData.stateLocationGuesser),
        );
        //--- Max Attempts maxGuessExhausted
        if (
          stateData.stateLocationGuesser.guesses &&
          Array.isArray(stateData.stateLocationGuesser.guesses) &&
          stateData.stateLocationGuesser.guesses[
            stateData.stateLocationGuesser.guesses.length - 1
          ] &&
          stateData.stateLocationGuesser.guesses[
            stateData.stateLocationGuesser.guesses.length - 1
          ].pointsEarned &&
          stateData.stateLocationGuesser.guesses[
            stateData.stateLocationGuesser.guesses.length - 1
          ].pointsEarned === 1000
        ) {
          showGameAlreadyPlayedPopup('perfectPointsGuessed');
        } else if (
          stateData.stateLocationGuesser.guesses &&
          Array.isArray(stateData.stateLocationGuesser.guesses) &&
          puzzle &&
          puzzle.maxAttempts &&
          stateData.stateLocationGuesser.guesses.length >= puzzle.maxAttempts
        ) {
          showGameAlreadyPlayedPopup('maxGuessExhausted');
        }
      }
    },
    [stateData, buttonClicked],
  );

  const onSubmitLocationGuesser = closePopup => {
    closePopup();
    fireGa4andGrx(
      'submit_game',
      'user_click_games',
      'gameplay',
      'location_guesser',
      isMobile,
      gameId,
      '',
      '',
      'submit',
    );
    gameSubmitCall(mapData.guesses);
  };

  useEffect(
    () => {
      if (hasGameAlreadyBeenPlayed && window?.lwPlayer?.lg) {
        setTimeout(() => {
          window.lwPlayer.lg.pause();
        }, 1500);
      }
    },
    [hasGameAlreadyBeenPlayed],
  );

  const handleLoaderEnd = () => {
    setIsLoading(false);
  };

  return (
    <>
      {isLoading &&
        !viewSolution && (
          <div className={s.animationLoader}>
            <LoaderSplash onAnimationEnd={handleLoaderEnd} />
          </div>
        )}
      {showCongrate &&
        puzzle && (
          <div>
            {!hideResultMap &&
              puzzle.latitude &&
              puzzle.longitude &&
              mapDataResultView.guesses.length > 0 && (
                <div className="congratulationsMap">
                  <Map
                    mapData={{
                      ...mapDataResultView,
                      solution: [
                        {
                          guessLatitude: puzzle.latitude,
                          guessLongitude: puzzle.longitude,
                        },
                      ],
                      isResultView: true,
                    }}
                    submitCallback={() => {}}
                    submitGuessCallback={() => {}}
                    isWebView
                    maxGuessAllowed={puzzle?.maxAttempts}
                    isMobile={isMobile}
                    errorCallback={() => {
                      overlayCall('errorPopUp');
                      setHideResultMap(true);
                    }}
                    gameId={gameId}
                  />
                </div>
              )}
            {!viewSolution &&
              resultData && (
                <CongratulationsNew
                  resultData={resultData}
                  gameId={gameId}
                  showCongrate={showCongrate}
                  playAgainCheck={buttonClicked === 'viewResult' ? '' : false}
                  type="location-guesser"
                  puzzleData={puzzle}
                  isMobile={isMobile}
                  buttonClicked={buttonClicked}
                />
              )}
            {showCongrate &&
              !viewSolution && (
                <div className={`${s.gameCardArea} `}>
                  <div className={s.gameWidget}>
                    {/* <div className={s.practiceCard}>
                      <PracticeCard
                        gameType={gameType}
                        isLargeCard={!isMobile}
                        ga4Category="congratulations"
                        gameId={gameId}
                        isMobile={isMobile}
                        pageTemplate="gameplay"
                      />
                    </div> */}
                    <MoreOnGames
                      gameType={gameType}
                      isMobile
                      forceLoadDataOnInit
                      isCogratulationsPage
                      cardProps={{ ga4Category: 'congratulations' }}
                      gameId={gameId}
                      moreOnGamesTitle="Explore More Games"
                    />
                    {/* <div className={s.gameCardList}>
                    <GameCardListing
                      cardsIncluded={
                        gameType && gameType === 'mini_crossword'
                          ? ['sudoku', 'crossword']
                          : ['sudoku', 'mini_crossword']
                      }
                      forceLoadDataOnInit
                      isCogratulationsPage
                      cardProps={{ ga4Category: 'congratulations' }}
                      loaderClass={
                        isMobile
                          ? 'congratulations_mobile'
                          : 'congratulations_desktop'
                      }
                    />
                  </div> */}
                  </div>
                </div>
              )}
            {!showCongrate &&
              !viewSolution &&
              showOverlay && (
                <GameOverlay
                  commonTranslations={commonTranslations}
                  gameSpecificTranslations={gameSpecificTranslations}
                  popUpType={popUpType}
                  gameOverlayCallback={gameOverlayCallback}
                  gameSubmitCallback={gameSubmitCallback}
                  gameType="location-guesser"
                  apiConfigData={apiConfigData}
                  mapData={mapData}
                  submitGuessCallback={submitGuessCallback}
                  maxGuessAllowed={puzzle?.maxAttempts}
                  onSubmitLocationGuesser={onSubmitLocationGuesser}
                  isMobile={isMobile}
                  errorCallback={() => {
                    overlayCall('errorPopUp');
                  }}
                  gameId={gameId}
                  failedAPI={failedAPI}
                />
              )}
          </div>
        )}
      {showLoader && (
        <div className={s.loaderouter}>
          <LoaderSpinner />
        </div>
      )}
      {!showCongrate &&
        !viewSolution && (
          <div className={s.guessPlayer}>
            <LocationGuesserPlayer
              puzzleData={puzzle}
              howtoPlaycheck={howtoPlaycheck}
              handlePlayerError={() => {
                overlayCall('errorPopUp');
              }}
              handleGameCallback={handleGameCallback}
              gameId={gameId}
            />
            {showOverlay && (
              <GameOverlay
                commonTranslations={commonTranslations}
                gameSpecificTranslations={gameSpecificTranslations}
                popUpType={popUpType}
                gameOverlayCallback={gameOverlayCallback}
                gameSubmitCallback={gameSubmitCallback}
                gameType="location-guesser"
                apiConfigData={apiConfigData}
                mapData={mapData}
                submitGuessCallback={submitGuessCallback}
                maxGuessAllowed={puzzle?.maxAttempts}
                onSubmitLocationGuesser={onSubmitLocationGuesser}
                isMobile={isMobile}
                errorCallback={() => {
                  overlayCall('errorPopUp');
                }}
                gameId={gameId}
              />
            )}
            {!hasGameAlreadyBeenPlayed &&
              !showOverlay && (
                <div className={s.playerGuess}>
                  <button
                    className={`${s.shadowBtn} ${s.guessBtn}`}
                    onClick={() => {
                      handleMap();
                      fireGa4andGrx(
                        'take_a_guess',
                        'user_click_games',
                        'gameplay',
                        'location_guesser',
                        isMobile,
                        gameId,
                        mapData &&
                        mapData.guesses &&
                        Array.isArray(mapData.guesses)
                          ? mapData.guesses.length + 1
                          : 1,
                      );
                    }}
                  >
                    Take a Guess ({mapData &&
                    mapData.guesses &&
                    Array.isArray(mapData.guesses)
                      ? mapData.guesses.length + 1
                      : 1}/{puzzle?.maxAttempts})
                  </button>
                </div>
              )}
          </div>
        )}
    </>
  );
};

LocationGuesserGame.propTypes = {
  isMobile: PropTypes.bool,
  puzzleAPI: PropTypes.shape({}),
  // isToday: PropTypes.bool,
};

LocationGuesserGame.defaultProps = {
  isMobile: false,
  puzzleAPI: {},
  // isToday: false,
};

const mapStateToProps = state => ({
  isPrime: state.isPrime,
  isMobile: state.isMobile,
  isFrmapp: state.isFrmapp,
  puzzleAPI: _get(state, 'toigames.puzzledata', ''),
  gamesmetawidget: _get(state, 'toigames.gamesmetawidget', {}),
  userData: state.login.userData,
  gamesconfigData: _get(state, 'toigames.gamesconfig', {}),
  todaysGame: _get(state, 'toigames.puzzledata.todaysGame', ''),
  apiConfigData: _get(
    state,
    'toigames.gamesconfig.gameCategories.LocationGuesser',
    '',
  ),
  stateData: state.toigames && state.toigames.locationguesserstate,
});

const mapDispatchToProps = dispatch => ({
  loadSyncUp: params => {
    dispatch(loadSyncUp(params));
  },
  loadLocationGuesserStateFetch: params => {
    dispatch(loadLocationGuesserStateFetch(params));
  },
  loadLocationGuesserStateSave: params => {
    dispatch(loadLocationGuesserStateSave(params));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(
  LocationGuesserGame,
);
